<template>
  <div class="artwork-modal">
    <div
      class="backdrop modal d-none d-lg-block h-100 w-100"
      @click="dismiss"
    ></div>

    <div class="description-container">
      <div class="description d-flex justify-content-center align-items-center">
        <artwork-description
          :artwork="artwork"
          class="w-100"
          v-if="artwork.id"
        />
        <div class="d-none d-lg-block" v-else>
          <font-awesome-icon slot="spinner" icon="spinner" size="2x" pulse />
        </div>
      </div>
    </div>

    <div class="content-container">
      <div class="content d-flex justify-content-center align-items-center">
        <artwork-content
          :artwork="artwork"
          class="w-100"
          v-show="!loading"
          v-if="artwork.id"
        />
        <div class="d-none d-lg-block" v-if="loading">
          <font-awesome-icon slot="spinner" icon="spinner" size="2x" pulse />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArtworkContent from "../components/ArtworkContent";
import ArtworkDescription from "../components/ArtworkDescription";
import { Artwork } from "../models";

export default {
  components: {
    ArtworkContent,
    ArtworkDescription
  },
  data() {
    return {
      user: window.user,
      artwork: {},
      loading: true,
      collecting: false
    };
  },
  watch: {
    "$route.params.artwork": {
      async handler(id) {
        if (!id) {
          return;
        }

        // Only the latest artwork requested may land; a missing or private one
        // goes home (like Profile) instead of spinning forever.
        const request = (this.lastLoad = {});
        this.loading = true;
        try {
          const artwork = await new Artwork({ id }).load();
          if (request === this.lastLoad) {
            this.artwork = artwork;
          }
        } catch (e) {
          if (request === this.lastLoad) {
            this.$router.push({ name: "home" });
          }
        } finally {
          if (request === this.lastLoad) {
            this.loading = false;
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    document.addEventListener("keydown", this.handleEsc);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleEsc);
  },
  methods: {
    handleEsc({ keyCode }) {
      if (keyCode === 27) {
        this.dismiss();
      }
    },
    dismiss() {
      // Opened straight from another site: going back would leave pixpills.
      if (this.$router.inAppNavigations > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "home" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/bootstrap-grid.scss";

.artwork-modal {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: transparent;
  z-index: 1031;

  @include media-breakpoint-up(lg) {
    flex-direction: row;
    justify-content: center;
    margin-top: -60px;
    padding: 28px 0;
  }
}

.description-container {
  z-index: 1000;

  @include media-breakpoint-up(lg) {
    position: fixed;
    top: 28px;
    left: calc(50% - 35% - 136.5px);
    margin: auto;
  }

  @media (min-width: 1997px) {
    left: calc(50% - 700px - 131.5px);
  }

  .description {
    background-color: white;

    @include media-breakpoint-up(lg) {
      width: 253px;
      min-height: 370px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 0.3rem;
      background-clip: padding-box;
    }
  }
}

.content-container {
  z-index: 1000;

  @include media-breakpoint-up(lg) {
    flex-basis: 70vw;
    max-width: 1400px;
    margin-left: 263px;
  }

  .content {
    background-color: white;

    @include media-breakpoint-up(lg) {
      min-height: calc(100vh - 56px);
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 0.3rem;
      background-clip: padding-box;
    }
  }
}

.backdrop {
  z-index: 999;
  background-color: black;
  opacity: 0.5;
  cursor: zoom-out;
}
</style>
